import { useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import moment from "moment";

/**
 * Use Authenticated Hook
 * Updated to support MSAL authentication
 */
export default () => {
    const { auth } = useSelector((state) => state);
    const { accounts } = useMsal();

    // Check MSAL authentication
    const isMsalAuthenticated = accounts.length > 0;
    const account = accounts[0];

    // Check MSAL token expiration from idTokenClaims
    let isMsalTokenExpired = false;
    if (account && account.idTokenClaims && account.idTokenClaims.exp) {
        const tokenExp = account.idTokenClaims.exp; // Unix timestamp in seconds
        const now = Math.floor(Date.now() / 1000); // Current time in seconds
        isMsalTokenExpired = now >= tokenExp;
    }

    // Check Redux token expiration
    const isReduxTokenExpired =
        Boolean(auth.expiryDate) && moment().isAfter(moment(auth.expiryDate));

    // Token is expired if either MSAL or Redux token is expired
    const isExpired = isMsalTokenExpired || isReduxTokenExpired;

    return {
        // Check both MSAL and Redux auth for token presence
        hasIdToken:
            isMsalAuthenticated ||
            Boolean(auth.idToken) ||
            Boolean(auth.isAuthenticated),
        hasAccountId: Boolean(auth.account && auth.account.id),
        isExpired,
        isDenied: Boolean(auth.account === undefined),
        user: auth.isAuthenticated ? auth : auth
    };
};
